/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductVariantTotals {
  brandId?: number;
  brandName?: string;
  defaultImageURL?: string;
  expiration?: string;
  externalId?: number;
  inStockAcquisition?: number;
  inStockFidelization?: number;
  inStockInfluencerB4A?: number;
  inStockReserveMarketing?: number;
  internalEAN?: string;
  productVariantId?: number;
  productVariantName?: string;
  totalCompositions?: number;
  totalGift?: number;
  totalIncentive?: number;
  totalResend?: number;
  totalTrade?: number;
}
